import ServiceBack from "../../assets/v2/service_back.png";
import React, {useEffect} from "react";

export default function CarousselSlide(
    {diapoData}
) {

    // useEffect(() => {
    //     console.log(diapoData);
    // }, [diapoData]);

    return <img src={diapoData.image} className="my-0 h-full rounded-2xl"/>
    // <div style={{'--image-url': `url(${diapoData.image})`}}
    //      className="bg-[image:var(--image-url)] bg-no-repeat my-0 h-full rounded-2xl">


        {/*<div className="flex">*/}
        {/*    <div className="bg-black text-3xl">{data.number}</div>*/}
        {/*    <div className="text-2xl">{data.title}</div>*/}
        {/*</div>*/}
        {/*{*/}
        {/*    data.subs.map((sub, index) => {*/}
        {/*        return <div>*/}
        {/*            <img src={sub.icon} alt="car"/>*/}
        {/*            <div>{sub.text}</div>*/}
        {/*        </div>*/}
        {/*    })*/}
        {/*}*/}
    // </div>
}